import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import FormControlLabel from "@mui/material/FormControlLabel";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";
import { createCompanyAsset } from "../../actions/asset";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import API from "../../Api/api";

import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";
import { NumericFormat } from "react-number-format";
const columns = [
  { id: "code", label: "CODE", minWidth: 170 },
  { id: "category", label: "Asset Pool", minWidth: 100 },
  {
    id: "location",
    label: "LOCATION",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "description",
    label: "DESCRIPTION",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "intangible",
    label: "INTANGIBLE CAT.",
    minWidth: 170,
    align: "right",
    format: (value) => value.toFixed(2),
  },
];

export default function Asset() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    borderRadius: "25px",
    transform: "translate(-50%, -50%)",
    width: 700,
    // height: 500,

    backgroundColor: `${mode === "dark" ? "#ccc" : "#ffffff"}`,
    color: `${mode === "dark" ? "#fff" : "#000"}`,

    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [open, setOpen] = React.useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCloseDetail = () => setOpenDetail(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const [age, setAge] = React.useState("daily");
  const [category] = React.useState("");
  const [location] = React.useState("");
  const [depreciationMethod] = React.useState("straight line");

  const categoryData = useSelector((state) => state.category);
  const locationData = useSelector((state) => state.location);
  const assetsData = useSelector((state) => state.assets);
  const intangibles = useSelector((state) => state.intangible);
  const rightOfUse = useSelector((state) => state.rightOfUse);
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const intangibleCat = [
    {
      asset_pool: "INTANGIBLES",
      code: "IA",
      intangible_category: "true",
      id: "6463e2c9b03c40ecfc0c8bm2",
    },
  ];
  const newCategory = [...categoryData, ...intangibleCat];

  const [companyAssetsData, setCompanyAssetsData] = React.useState({
    description: "",
    category: category,
    location: location,
    sub_location: "",
    cost: "",
    purchase_date: "",
    depreciation_rate: "",
    depreciation_method: "",
    residual_value: "",
    supplier: "",
    purchase_invoice_number: "",
    purchase_receipt_number: "",
    serial_number: "",
    intangible_asset: false,
  });
  const handleChangeCheck = (event) => {
    let isChecked = event.target.checked;
    setCompanyAssetsData({ ...companyAssetsData, intangible_asset: isChecked });
  };
  const handleChangeCategory = (event) => {
    setCompanyAssetsData({
      ...companyAssetsData,
      category: event.target.value,
    });
  };
  const handleChangeLocation = (event) => {
    setCompanyAssetsData({
      ...companyAssetsData,
      location: event.target.value,
    });
  };
  const handleChangeDepreciationMethod = (event) => {
    setCompanyAssetsData({
      ...companyAssetsData,
      depreciation_method: event.target.value,
    });
  };

  const assetLife = (100 / companyAssetsData.depreciation_rate) * 1 * 365;

  const exhaustion_date = moment(companyAssetsData.purchase_date).add(
    assetLife,
    "days"
  );
  const fomartDate = moment(exhaustion_date).format("YYYY-MM-DD");

  const dailyDepreciation =
    (companyAssetsData.cost * 1 - companyAssetsData.residual_value * 1) /
    assetLife;
  const [locationCode, setLocationCode] = React.useState("");
  const [categoryCode, setCategoryCode] = React.useState("");
  const cat = companyAssetsData.category.toLowerCase();
  const [cateNumber, setCatNumber] = React.useState("");
  const [generatingCode, setGeneratingCode] = React.useState(false);
  const [details, setDetails] = React.useState([]);

  React.useEffect(() => {
    const fetch = async () => {
      if (companyAssetsData.category) {
        setGeneratingCode(true);
        const res = await API.get(
          `/api/v1/company-assets/ppe/ppe-section?category=${cat}`
        );
        if (res.data.length < 10) {
          const num = res.data.length + 1;
          setCatNumber("000" + num);
          setGeneratingCode(false);
          return;
        } else if (res.data.length >= 10) {
          const num = res.data.length + 1;
          setCatNumber("00" + num);
          setGeneratingCode(false);
          return;
        } else if (res.data.length >= 100) {
          const num = res.data.length + 1;
          setCatNumber("0" + num);
          setGeneratingCode(false);
          return;
        } else if (res.data.length >= 10000) {
          // eslint-disable-next-line no-lone-blocks
          {
            const num = res.data.length + 1;
            setCatNumber(num);
            setGeneratingCode(false);
            return;
          }
        }
      }
    };
    fetch();
  }, [companyAssetsData.category, cat]);

  let actualData = {
    description: companyAssetsData.description,
    code: `RSS/${locationCode}/${categoryCode}/${new Date(
      companyAssetsData.purchase_date
    ).getFullYear()}/${cateNumber}`,
    category: companyAssetsData.category,
    location: companyAssetsData.location,
    sub_location: companyAssetsData.sub_location,
    cost: companyAssetsData.cost,
    purchase_date: companyAssetsData.purchase_date,
    depreciation_rate: companyAssetsData.depreciation_rate,
    residual_value: companyAssetsData.residual_value,
    supplier: companyAssetsData.supplier,
    purchase_invoice_number: companyAssetsData.purchase_invoice_number,
    purchase_receipt_number: companyAssetsData.purchase_receipt_number,
    serial_number: companyAssetsData.serial_number,
    intangible: companyAssetsData.intangible_asset,
    asset_life: assetLife,
    exhaustion_date: fomartDate,
    daily_depreciation: dailyDepreciation,
    uploaded_by: user.results.firstName + " " + user.results.lastName,
  };
  const dispatch = useDispatch();
  function clear() {
    setCompanyAssetsData({
      description: "",
      category: "",
      location: "",
      sub_location: "",
      cost: "",
      purchase_date: "",
      depreciation_rate: "",
      depreciation_method: "",
      residual_value: "",
      supplier: "",
      purchase_invoice_number: "",
      purchase_receipt_number: "",
      serial_number: "",
      intangible_asset: false,
    });
  }
  function sendData() {
    if (moment(companyAssetsData.purchase_date) > moment()) {
      toast.error("purchase date can't be ahead of today");
      return;
    }
    if (
      companyAssetsData.purchase_date &&
      companyAssetsData.cost &&
      companyAssetsData.location &&
      companyAssetsData.category &&
      companyAssetsData.depreciation_rate
    ) {
      dispatch(createCompanyAsset(actualData));
      setTimeout(() => {
        clear();
        setOpen(false);
      }, 2000);
    } else {
      toast.error(
        "Please fill in required fields in addition to other relevant info."
      );
    }
  }

  let allowManipulate;
  if (
    user.results.assets === "Administrator" ||
    user.results.assets === "Read-Write"
  ) {
    allowManipulate = false;
  } else {
    allowManipulate = true;
  }
  const [allAssets, setAllAsset] = React.useState([
    ...assetsData,
    ...intangibles,
    ...rightOfUse,
  ]);
  const [searchCode, setSearchCode] = React.useState("");
  function searchAssets() {
    if (searchCode) {
      const search = allAssets.filter((obj) => obj.code === searchCode);
      setAllAsset(search);
    } else {
      setAllAsset([...assetsData, ...intangibles, ...rightOfUse]);
    }
  }

  return (
    <div
      style={{
        height: "calc(73dvh - 100px)",
      }}
    >
      <Helmet>
        <title>Add New Asset</title>
      </Helmet>
      <Paper
        style={{
          backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
          color: `${mode === "dark" ? "#fff" : "#000"}`,
        }}
        sx={{ width: "100%" }}
      >
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography
                id="transition-modal-title"
                variant="h5"
                component="h2"
                style={{
                  marginBottom: "15px",
                  color: "#000000",
                }}
              >
                Add Asset
              </Typography>
              <form
                style={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "20px",
                  justifyContent: "space-around",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Description"
                    value={companyAssetsData.description}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        description: e.target.value,
                      })
                    }
                    required
                  />
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={companyAssetsData.category}
                      onChange={handleChangeCategory}
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {newCategory?.map((data) => {
                        return (
                          <MenuItem
                            onClick={() => setCategoryCode(data.code)}
                            key={data.id}
                            value={data.asset_pool}
                          >
                            {data.asset_pool}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel required id="demo-simple-select-standard-label">
                      Location
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={companyAssetsData.location}
                      onChange={handleChangeLocation}
                      label="Category"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {locationData?.map((data) => {
                        return (
                          <MenuItem
                            onClick={() => setLocationCode(data.code)}
                            key={data.id}
                            value={data.name}
                          >
                            {data.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="text"
                    size="small"
                    label="Sub-Location"
                    value={companyAssetsData.sub_location}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        sub_location: e.target.value,
                      })
                    }
                  />
                  <NumericFormat
                    customInput={TextField}
                    label="cost"
                    size="small"
                    required
                    style={{ marginBottom: "10px" }}
                    thousandSeparator=","
                    decimalScale={2}
                    allowNegative={true}
                    value={companyAssetsData.cost}
                    onValueChange={(values) => {
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        cost: values.floatValue, // <== clean numeric value (no commas)
                      });
                    }}
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="date"
                    size="small"
                    label="Purchase Date"
                    value={companyAssetsData.purchase_date}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        purchase_date: e.target.value,
                      })
                    }
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    pattern="[0-9]+"
                    label="Depreciation Rate(%)"
                    value={companyAssetsData.depreciation_rate}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        depreciation_rate: e.target.value,
                      })
                    }
                    required
                  />
                  {companyAssetsData.depreciation_rate * 1 < 1 ? (
                    <em style={{ color: "red" }}>
                      NB: value shouldn't be less than one
                    </em>
                  ) : (
                    ""
                  )}

                  <FormControlLabel
                    style={{ color: "#000000" }}
                    control={
                      <Checkbox
                        onChange={handleChangeCheck}
                        name="intangible_asset"
                      />
                    }
                    label="Intangible Asset?"
                  />
                  <div>
                    <Button
                      disabled={generatingCode}
                      onClick={sendData}
                      variant="contained"
                      size="small"
                      style={{
                        textTransform: "none",
                        margin: "5px",
                        backgroundColor: "#116149",
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                      }}
                      onClick={handleClose}
                      size="small"
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        backgroundColor: "#D32F2F",
                        marginLeft: "5px",
                      }}
                      onClick={clear}
                      size="small"
                    >
                      Clear form
                    </Button>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    style={{ marginBottom: "10px" }}
                    type="number"
                    size="small"
                    label="Residual Value"
                    value={companyAssetsData.residual_value}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        residual_value: e.target.value,
                      })
                    }
                  />
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Depreciation Frequency
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={age}
                      onChange={handleChange}
                      disabled
                      label="Age"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={"daily"}>Daily</MenuItem>
                      <MenuItem value={"monthly"}>Monthly</MenuItem>
                      <MenuItem value={"yearly"}>Yearly</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      Depreciation Method
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={depreciationMethod}
                      onChange={handleChangeDepreciationMethod}
                      disabled
                      label="Depreciation Method"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={"straight line"}>Straight Line</MenuItem>
                      <MenuItem value={"reducing balance"}>
                        Reducing Balance
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="Supplier"
                    value={companyAssetsData.supplier}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        supplier: e.target.value,
                      })
                    }
                    required
                  />
                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="purchase invoice No."
                    value={companyAssetsData.purchase_invoice_number}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        purchase_invoice_number: e.target.value,
                      })
                    }
                    required
                  />
                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="purchase receipt No."
                    value={companyAssetsData.purchase_receipt_number}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        purchase_receipt_number: e.target.value,
                      })
                    }
                    required
                  />
                  <TextField
                    type="text"
                    size="small"
                    style={{ marginBottom: "10px" }}
                    label="Serial/Chassis No."
                    value={companyAssetsData.serial_number}
                    onChange={(e) =>
                      setCompanyAssetsData({
                        ...companyAssetsData,
                        serial_number: e.target.value,
                      })
                    }
                  />
                  {generatingCode && (
                    <span className="blinking-text">
                      Please wait i am generating the asset code
                    </span>
                  )}
                </div>
              </form>
            </Box>
          </Fade>
        </Modal>
        {openDetail && (
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDetail}
            onClose={handleCloseDetail}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDetail}>
              <Box sx={style}>
                <Typography
                  id="transition-modal-title"
                  variant="h5"
                  component="h2"
                  style={{ marginBottom: "15px" }}
                >
                  Asset Details
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "20px",
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset code"
                      value={details[0].code}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset pool"
                      value={details[0].category}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset location"
                      value={details[0].location}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset description"
                      value={details[0].description}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="purchase date"
                      value={new Date(
                        details[0].purchase_date
                      ).toLocaleDateString()}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="exhaustion date"
                      value={new Date(
                        details[0].exhaustion_date
                      ).toLocaleDateString()}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="asset cost"
                      value={details[0].cost}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="daily depreciation"
                      value={details[0].daily_depreciation}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="depreciation rate"
                      value={details[0].depreciation_rate + "%"}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="supplier"
                      value={details[0].supplier}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="uploaded by"
                      value={details[0].uploaded_by}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="approval status"
                      value={details[0].approved}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="revaluation status"
                      value={details[0].revalued}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="revalued by"
                      value={details[0].revalued_by}
                    />
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="disposal status"
                      value={details[0].disposed}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"space-between"}
                    flexDirection={"row"}
                  >
                    <TextField
                      size="small"
                      type="text"
                      disabled
                      label="disposed by"
                      value={details[0].disposed_by}
                    />
                    <div>
                      <Button
                        style={{
                          textTransform: "none",
                          marginRight: "10px",
                          backgroundColor: "#17B859",
                        }}
                        variant="contained"
                        size="small"
                      >
                        Edit
                        <EditIcon style={{ fontSize: "18px" }} />
                      </Button>
                      <Button
                        style={{
                          textTransform: "none",
                          marginRight: "5px",
                          backgroundColor: "#3D4F58",
                        }}
                        variant="contained"
                        size="small"
                      >
                        Submit <SendIcon style={{ fontSize: "18px" }} />
                      </Button>
                    </div>
                  </Box>
                </div>
              </Box>
            </Fade>
          </Modal>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button
            disabled={allowManipulate}
            style={{
              textTransform: "capitalize",
              margin: "5px",
              backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            onClick={handleOpen}
            variant="contained"
          >
            Add Asset
          </Button>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-around"}
            justifyItems={"center"}
          >
            <InputLabel
              style={{ color: `${mode === "dark" ? "#ffffff" : "#000000"}` }}
            >
              search asset
            </InputLabel>
            <TextField
              style={{
                margin: "5px",
                color: `${mode === "dark" ? "#ffffff" : "#000000"}`,
                backgroundColor: `${mode === "dark" ? "#cccccc" : "#ffffff"}`,
                borderRadius: "5px",
              }}
              value={searchCode}
              onChange={(e) => setSearchCode(e.target.value)}
              size="small"
              type="search"
              placeholder="enter asset code here"
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton
                      onClick={searchAssets}
                      style={{ backgroundColor: "#ccc" }}
                    >
                      <SearchIcon style={{ color: "#000" }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </div>
        <em style={{ color: "red" }}>
          {allowManipulate ? "you don't have the permission to add asset" : ""}
        </em>
        <TableContainer
          style={{
            backgroundColor: `${mode === "dark" ? "#303030" : "#ffffff"}`,
            color: `${mode === "dark" ? "#fff" : "#000"}`,
            height: "calc(77dvh - 100px)",
          }}
        >
          <Table
            size="small"
            stickyHeader
            aria-label="sticky table"
            // style={{ backgroundColor: "#cccc" }}
            sx={{
              "& tr > *:last-child": {
                position: "sticky",
                right: 0,

                // bgcolor: "#cccc",
              },
            }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 0,
                      minWidth: column.minWidth,
                      backgroundColor: "#3D4F58",
                      color: "white",
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  style={{ backgroundColor: "#3D4F58", color: "white" }}
                >
                  ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allAssets
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              backgroundColor: `${
                                mode === "dark" ? "#303030" : "#ffffff"
                              }`,
                              color: `${
                                mode === "dark"
                                  ? "rgba(255,255,255,0.65)"
                                  : "#000"
                              }`,
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            fontSize: "14px",
                          }}
                        >
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => {
                                setDetails(
                                  allAssets.filter((obj) => obj._id === row._id)
                                );
                                setOpenDetail(true);
                              }}
                            >
                              <VisibilityIcon
                                style={{
                                  fontSize: "18px",

                                  backgroundColor: `${
                                    mode === "dark" ? "#303030" : "#ffffff"
                                  }`,
                                  color: `${
                                    mode === "dark" ? "#fff" : "#292A2D"
                                  }`,
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View">
                            <IconButton disabled>
                              <DeleteIcon
                                style={{
                                  fontSize: "18px",

                                  backgroundColor: `${
                                    mode === "dark" ? "#101418" : "#ffffff"
                                  }`,
                                  color: `${
                                    mode === "dark" ? "#fff" : "#292A2D"
                                  }`,
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          style={{ color: mode === "dark" ? "#ffffff" : "#000000" }}
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={allAssets.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
